import { IEnv } from './env.type'

export const environment: IEnv = {
  PRODUCTION: true,
  API_PREFIX: 'https://api.scienceglamping.com',
  WEBSOCKET_PREFIX: 'wss://api.scienceglamping.com',
  CABINET_PREFIX: 'https://my.scienceglamping.com',
}
